module.exports = __webpack_public_path__ + "media/images/solution3-b61b5325d1db667bf6571ca054080a19.svg";